import { BaseCommon } from "./base-common.abstract";
export class BaseStorePage extends BaseCommon {
    setTagsSet() {
        this.tagsSet = new Set();
        // this optional chaining on tags isn't really needed
        // only added so I don't have to track down every single test fixture
        this.currentPage?.tags?.forEach(hint => this.tagsSet.add(hint.id));
    }
}
//# sourceMappingURL=base-page.abstract.js.map